import { useEffect, useMemo, useState } from 'react';

const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)';

/** Tracks OS / browser light-dark preference with the modern MediaQueryList change API. */
export function usePrefersDarkColorScheme(): boolean {
  const mediaQuery = useMemo(
    () =>
      typeof window.matchMedia === 'function'
        ? window.matchMedia(DARK_SCHEME_QUERY)
        : undefined,
    [],
  );

  const [prefersDark, setPrefersDark] = useState(
    () => mediaQuery?.matches ?? false,
  );

  useEffect(() => {
    if (!mediaQuery) {
      return undefined;
    }

    const listener = (event: MediaQueryListEvent) => {
      setPrefersDark(event.matches);
    };

    mediaQuery.addEventListener('change', listener);
    setPrefersDark(mediaQuery.matches);

    return () => {
      mediaQuery.removeEventListener('change', listener);
    };
  }, [mediaQuery]);

  return prefersDark;
}
